/* The Gift Shop — carrosseis de produto.
   Scroll nativo, arrasto com inercia no desktop e uma barra que acompanha a
   posicao e tambem serve para navegar. O add to cart usa /cart/add.js e depois
   pede ao tema para recarregar o carrinho. */
(function () {
  'use strict';

  // Cada section de produtos pede este arquivo, entao a tag pode aparecer mais
  // de uma vez na pagina; so a primeira execucao vale.
  if (window.__giftShopCarousels) return;
  window.__giftShopCarousels = true;

  function initCarousel(root) {
    if (root.dataset.gsCarouselReady === 'true') return;
    root.dataset.gsCarouselReady = 'true';

    var track = root.querySelector('[data-gs-track]');
    if (!track) return;

    var bar = root.querySelector('[data-gs-progress]');
    var rail = bar ? bar.parentElement : null;

    function overflow() {
      return track.scrollWidth - track.clientWidth;
    }

    function update() {
      var max = overflow();

      // Sem overflow nao ha o que navegar: a barra sai e os cards centram.
      root.classList.toggle('is-static', max <= 1);
      if (!bar || max <= 1) return;

      var railWidth = rail.clientWidth;
      var ratio = Math.min(1, track.clientWidth / track.scrollWidth);
      var offset = Math.min(1, Math.max(0, track.scrollLeft / max));

      bar.style.width = ratio * 100 + '%';
      bar.style.transform = 'translateX(' + offset * (railWidth - railWidth * ratio) + 'px)';
    }

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update);

    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);

    track.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', update, { once: true });
    });

    window.requestAnimationFrame(update);
    window.addEventListener('load', update);

    // ---- arrasto com inercia (mouse; no toque o scroll nativo ja resolve) ----
    var dragging = false;
    var moved = 0;
    var startX = 0;
    var startScroll = 0;
    var lastX = 0;
    var lastTime = 0;
    var velocity = 0;
    var glide = null;

    function stopGlide() {
      if (glide) {
        cancelAnimationFrame(glide);
        glide = null;
      }
    }

    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch' || event.button !== 0) return;
      stopGlide();
      dragging = true;
      moved = 0;
      velocity = 0;
      startX = lastX = event.clientX;
      startScroll = track.scrollLeft;
      lastTime = event.timeStamp;
    });

    track.addEventListener('pointermove', function (event) {
      if (!dragging) return;

      var delta = event.clientX - startX;
      if (Math.abs(delta) > 3) {
        moved = Math.abs(delta);
        track.classList.add('is-dragging');
        if (track.setPointerCapture) track.setPointerCapture(event.pointerId);
      }

      var dt = event.timeStamp - lastTime;
      if (dt > 0) {
        // px por frame de 16ms, suavizado para o ultimo gesto nao dominar
        var v = ((event.clientX - lastX) / dt) * 16;
        velocity = velocity * 0.7 + v * 0.3;
        lastX = event.clientX;
        lastTime = event.timeStamp;
      }

      track.scrollLeft = startScroll - delta;
    });

    function endDrag() {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');

      // Solta deslizando, como um carrossel de toque.
      if (Math.abs(velocity) < 1) return;

      var v = Math.max(-60, Math.min(60, velocity));
      (function step() {
        v *= 0.94;
        track.scrollLeft -= v;
        var at_edge = track.scrollLeft <= 0 || track.scrollLeft >= overflow();
        glide = Math.abs(v) > 0.4 && !at_edge ? requestAnimationFrame(step) : null;
      })();
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', endDrag);

    // Um arrasto nao deve virar clique no card embaixo do cursor.
    track.addEventListener('click', function (event) {
      if (moved > 5) {
        event.preventDefault();
        event.stopPropagation();
        moved = 0;
      }
    }, true);

    track.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    track.addEventListener('wheel', stopGlide, { passive: true });

    // ---- a barra tambem navega ----
    if (rail) {
      var scrubbing = false;

      function scrubTo(clientX) {
        var box = rail.getBoundingClientRect();
        var ratio = Math.min(1, track.clientWidth / track.scrollWidth);
        var usable = box.width * (1 - ratio);
        if (usable <= 0) return;
        var pos = clientX - box.left - (box.width * ratio) / 2;
        track.scrollLeft = (Math.min(usable, Math.max(0, pos)) / usable) * overflow();
      }

      rail.addEventListener('pointerdown', function (event) {
        if (overflow() <= 1) return;
        stopGlide();
        scrubbing = true;
        rail.setPointerCapture(event.pointerId);
        scrubTo(event.clientX);
      });

      rail.addEventListener('pointermove', function (event) {
        if (scrubbing) scrubTo(event.clientX);
      });

      ['pointerup', 'pointercancel'].forEach(function (type) {
        rail.addEventListener(type, function () { scrubbing = false; });
      });
    }
  }

  function initAtc(button) {
    if (button.dataset.gsAtcReady === 'true') return;
    button.dataset.gsAtcReady = 'true';

    button.addEventListener('click', function () {
      var variantId = button.dataset.variantId;
      if (!variantId || button.getAttribute('aria-busy') === 'true') return;

      button.setAttribute('aria-busy', 'true');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function () {
            var miniCart = document.querySelector('#mini-cart');
            if (miniCart) miniCart.setAttribute('open', '');
          }, 500);
        })
        .catch(function (error) { console.error(error); })
        .finally(function () { button.removeAttribute('aria-busy'); });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-gs-carousel]').forEach(initCarousel);
    (scope || document).querySelectorAll('[data-gs-atc]').forEach(initAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // O editor de temas recria a secao sem recarregar a pagina.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
